"use client"

import React from 'react';
import { useConfig } from 'components/ConfigProvider';

export function initializeBugsnag(config) {
    let Bugsnag = null;
    if (config.bugSnag && config.bugSnag.apiKey) {
        const releaseStage =
            config.profile === "prod"
                ? "production"
                : config.profile === "qa"
                    ? "staging"
                    : "development"

        if (typeof window !== "undefined") {
            // client
            const bugsnagJs = require("@bugsnag/js")
            const BugsnagPluginReact = require("@bugsnag/plugin-react").default

            Bugsnag = bugsnagJs.default || bugsnagJs

            Bugsnag.start({
                apiKey: config.bugSnag.apiKey,
                plugins: [new BugsnagPluginReact()],
                releaseStage,
                appVersion: "1.0.0",
                onError: function(event) {
                    // try {
                    //     const { useAuth } = require("src/providers/auth-provider")
                    //     const uAuth = useAuth?.()
                    //     if (uAuth?.user) {
                    //         const { user } = uAuth
                    //         event.setUser(user.email || user.sub)
                    //     }
                    // } catch (err) {
                    //     // ignore
                    // }
                }
            })
        }
    }

    return Bugsnag;
}

export function ErrorBoundary({ children }) {
    const config = useConfig();
    const bugsnagClient = initializeBugsnag(config);
    const ErrorBoundary = bugsnagClient?.getPlugin('react')?.createErrorBoundary(React);

    if (!ErrorBoundary) return children;

    return (
        <ErrorBoundary FallbackComponent={() => <h1>Oops, something went wrong</h1>}>
            {children}
        </ErrorBoundary>
    );
}


